import { Component, Input, OnInit } from '@angular/core';
import { DatastoreService } from '../../services/datastore.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent implements OnInit {
  @Input() notification: string = ''; // the underscore seperated name of the Business Question which contains the desired notification

  constructor(private datastoreService: DatastoreService) {}

  ngOnInit(): void {}
  
}
